// extracted by mini-css-extract-plugin
module.exports = {"tableBody":"easter-egg-styles_tableBody__wPz1O","confetti":"easter-egg-styles_confetti__tILvT","confettiItem":"easter-egg-styles_confettiItem__t_uHs"};